
























import { Vue, Component, Prop } from 'vue-property-decorator';
import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";

@Component({
  components: {
    HelpPopupComponent,
    UiStatusBarComponent
  }
})
export default class DashboardProgressBlockComponent extends Vue {
  @Prop()
  public title: string;

  @Prop()
  public totalPercent: number;

  @Prop()
  public recentPercent: number;
}
